import React, { useMemo } from "react";
import Menu from "devextreme-react/menu";
import MdaePopover from "../popover";
import "./index.scss";
import $ from "jquery";
import { IMdaePopoverProps } from "../popover";
import { useSelector } from "react-redux";

type IMdaeDataGridActionPopoverProps = {
  mdaePopoverConfig: IMdaePopoverProps;
  menuItemList?: Array<IActionMenuItem>;
  menuItemListFunction?: () => Array<IActionMenuItem>;
  onActionPopoverHiding?: any;
};
interface IActionMenuItem {
  icon: any;
  text: string;
  onClick: any;
}
const onDataGridActionPoroverShowing = (e) => {
  var currentTarget = e.component.option("target");
  var dxMenuInstance = $(e.component.element())
    .find("div[is-resize-on-popover-load]")
    .data("dxMenu");
  if (dxMenuInstance) {
    dxMenuInstance.repaint();
  }

  $($(currentTarget).parents("td")[0]).addClass(
    "mdae-datagrid-action-ellipsis-cell"
  );
  $($(currentTarget).parents("td")[0]).addClass(
    "selected-action-ellipsis-cell"
  );
  setTimeout(function() {
    $($(currentTarget).parents("td")[0]).removeClass(
      "mdae-datagrid-action-ellipsis-cell"
    );
    $($(currentTarget).parents("td")[0]).removeClass(
      "selected-action-ellipsis-cell"
    );
  }, 100);
};
const ActionMenuItemIcon = (data) => {
  return (
    <div className={"mdae-datagrid-action-menu-item-icon"}>{data.icon()}</div>
  );
};
const ActionMenuItem = (itemData) => {
  return (
    <div className={"mdae-datagrid-action-menu-item"}>
      <ActionMenuItemIcon {...itemData} />
      <div className={"sys-user-menu-action-item-text"}>{itemData.text}</div>
    </div>
  );
};
const MdaeActionPopover: React.FC<IMdaeDataGridActionPopoverProps> = (
  props
) => {
  const selectedRowId = useSelector(
    (state) =>
      state["mdaeCommonReducer"].genericDataGridSelectedRowId
  );
  const menuItemList = useMemo(
    () =>
      typeof props?.menuItemListFunction === "function"
        ? props?.menuItemListFunction()
        : props.menuItemList,
    [selectedRowId, props.menuItemList]
  );
  return (
    <MdaePopover
      {...props.mdaePopoverConfig}
      className={"mdae-menu-list-popover"}
      position={
        props.mdaePopoverConfig.position || {
          at: "left bottom",
          my: "left top",
          offset: { x: 0, y: 0 },
        }
      }
      animation={{
        show: {
          type: "pop",
          from: { scale: 0 },
          to: { scale: 1 },
        },
        hide: {
          type: "fade",
          from: 1,
          to: 0,
        },
      }}
      onShowing={onDataGridActionPoroverShowing}
    >
      <Menu
        orientation={"vertical"}
        dataSource={menuItemList}
        itemRender={(itemData) => {
          return <ActionMenuItem {...itemData} />;
        }}
      ></Menu>
    </MdaePopover>
  );
};
export default MdaeActionPopover;
